import { supabase } from '@/lib/supabase';
import { ChatMessage, MessageRole } from '@/types';

/**
 * Save a chat message to the database
 * @param message The chat message to save
 */
export async function saveChatMessage(
  message: ChatMessage, 
  instagramUsername: string,
  personaId?: string
) {
  try {
    const { data: sessionData } = await supabase.auth.getSession();
    if (!sessionData?.session?.user) {
      throw new Error('User not authenticated');
    }
    
    // Insert the message into the database
    const { data, error } = await supabase
      .from('chat_messages')
      .insert({
        user_id: sessionData.session.user.id,
        instagram_username: instagramUsername,
        content: message.content,
        role: message.role,
        credits_used: message.role === MessageRole.Bot ? 1 : 0, // Only count bot messages as using credits
        persona_id: personaId,
        message_id: message.id
      })
      .select('*')
      .single();
    
    if (error) {
      console.error('Error saving chat message:', error);
      throw error;
    }
    
    return data;
  } catch (error) {
    console.error('Error in saveChatMessage:', error);
    // Don't throw so chat can still work even if saving to DB fails
    return null;
  }
}